/**
 * 文件简介：
 * - 大屏子组件共用的生命周期打点 mixin（mount / destroy 计入 __screenLifecycleStats）
 * 使用方法：混入 SleepViewDefault / Welcome / Video / FullscreenWelcome 等
 */

import screenLifecycleStats from '@/utils/screenLifecycleStats';

export default {
  mounted() {
    const name = this.$options.name || 'Anonymous';
    screenLifecycleStats.recordComponentMount(name);
  },
  beforeDestroy() {
    const name = this.$options.name || 'Anonymous';
    screenLifecycleStats.recordComponentDestroy(name);
  },
};
